import React, { useState, useEffect } from "react";
import { cartItemListProps } from "../../../infrastructure/GlobalContextProvider";
import ModeofPayment from "../modeOfPayment/modeOfPayment";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import styles from "./cartItems.module.scss";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCloseIcon,
  formatAmount,
} from "../StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserName,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import { isNil } from "lodash";
import ToastError from "../toast/toastError";
import toast from "react-hot-toast";
import ToastSuccess from "../toast/toastSuccess";
import commonStyles from "../../../App.module.scss";
import LOCALE from "../../../config/en-us.json";
import { IconButton } from "@mui/material";
import constants from "../../../config/constants.json";
import ManagerCreditCardPayment from "../../managerDashboard/managerCartItems/managerCreditCardPayment";
import ManagerCheckPayment from "../../managerDashboard/managerCartItems/managerCheckPayment";
import DevoteeModeOfPayment from "../modeOfPayment/devoteeModeOfPayment";
import ModeOfPayment from "../modeOfPayment/modeOfPayment";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../ErrorPopup";
import ManagerPayPalCartItems from "../../managerDashboard/managerCartItems/managerPayPalCartItems";

const CartItemsComponent = (props: any) => {
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [cartItemIds, setCartItemIds] = useState<any[]>([]);
  const [paymentButton, setpaymentButton] = useState(true);
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [totalTangibleAmount, setTotalTangibleAmount] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null | undefined>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );
  const [showManagerCreditCard, setShowManagerCreditCard] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [renderPaymentType, setRenderPaymentType] = useState<string | null>(
    null
  );
  const [selectedPaymentType, setSelectedPaymentType] = useState<string | null>(
    null
  );
  const [payPalAddToCart,setPayPalAddToCart]=useState(null);

  useEffect(() => {
    getCartItems();
  }, []);

  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: hasManagerLevelRole
          ? getDevoteeId()?.userId.toUpperCase()
          : getUserName()?.toUpperCase(),
      },
    })
      .then((res) => {
        setPayPalAddToCart(res.data)
        const cartItemObjects = res.data.bookedItemInCart.map(
          (item: cartItemListProps) => ({
            itemId: item.id, // Create an object with itemId as the key and item's id as the value
          })
        );
        setcartItemsList(res.data.bookedItemInCart);
        setCartItemIds(cartItemObjects);
        sessionStorage.setItem("cartItems", JSON.stringify(cartItemObjects));
        setTotalDonationAmount(res.data.totalAmount);
        setTotalTangibleAmount(res.data.totalTanAmount);
      })
      .catch((err) => {
        console.log(err);

        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const tableComponent = () => {
    return (
      <div style={{ overflowY: "auto" }}>
        {cartItemsList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Type</th>
                <th className={styles.tableHorizontal}>Pooja/Hall Name</th>
                <th className={styles.tableHorizontal}>Priest Name</th>
                {/* <th className={styles.tableHorizontal}>Pooja Title</th> */}
                <th className={styles.tableHorizontal}>Deities</th>
                <th className={styles.tableHorizontal}>Date of Pooja</th>
                <th className={styles.tableHorizontal}>Donation Purpose</th>
                <th className={styles.tableHorizontal}>Description</th>
                <th
                  className={styles.tableHorizontal}
                  style={{ textAlign: "right" }}
                >
                  Suggested Donation Amount
                </th>
                <th
                  className={styles.tableHorizontal}
                  style={{ textAlign: "right" }}
                >
                  Tangible Amount
                </th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="cartItemsList">
              {cartItemsList.map((item: cartItemListProps, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>{item?.type}</td>
                  <td className={styles.tableDiagonal}>
                    {item.poojaOrHallName}
                  </td>
                  <td className={styles.tableDiagonal}>{item.priestName}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.deities?.map((diety) => (
                      <>
                        {diety}
                        <br />
                      </>
                    ))}
                  </td>
                  <td className={styles.tableDiagonal}>{item?.dateOfPooja}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.donationPurpose}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {isNil(item?.description) ? (
                      ""
                    ) : (
                      <span>{item?.description}</span>
                    )}
                    <br />
                    {isNil(item?.vastraCategory) &&
                    isNil(item?.vastraExchange) ? (
                      ""
                    ) : (
                      <>
                        <span style={{ fontWeight: "bold" }}>
                          Vastra Category{" "}
                        </span>
                        : {item.vastraCategory},{" "}
                        <span style={{ fontWeight: "bold" }}>
                          Vastra Exchange{" "}
                        </span>
                        : {item.vastraExchange}
                      </>
                    )}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{ textAlign: "right" }}
                  >
                    {formatAmount(item?.amount)}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{ textAlign: "right" }}
                  >
                    {formatAmount(item?.tangibleAmount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    <img
                      src={deleteIcon}
                      alt="delete item"
                      style={{ cursor: "pointer" }}
                      onClick={() => openConfirmPopUp(item?.id)}
                    />
                  </td>
                </tr>
              ))}
              {cartItemsList.length > 0 && (
                <tr className={styles.tableTotalRow}>
                  <td colSpan={7} style={{textAlign: "left", padding: "5px"}}>Total</td>
                  <td colSpan={1} style={{textAlign: "right"}}>{formatAmount(totalDonationAmount)}</td>
                  <td colSpan={1} style={{textAlign: "right"}}>{formatAmount(totalTangibleAmount)}</td>
                  <td colSpan={1}></td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
        {/* {cartItemsList.length > 0 && (
          <div className={styles.totalAmount}>
            <span className={styles.totaltext}>Total </span>
            <p>{formatAmount(totalDonationAmount)}</p>
            <p>{formatAmount(totalTangibleAmount)}</p>
          </div>
        )} */}
      </div>
    );
  };

  // const handleMakePayment = () => {
  //   sessionStorage.setItem("cartItems", JSON.stringify(cartItemIds));
  //   setShowPayment(true);
  //   // navigate(
  //   //   `/creditPayment?amount=${totalDonationAmount}&donationType=bookPooja`
  //   // );

  // };

  const handleMakePayment = () => {
    sessionStorage.setItem("cartItems", JSON.stringify(cartItemIds));
    if (!hasManagerLevelRole) {
      navigate(
        `/creditPayment?amount=${totalDonationAmount}&donationType=bookPooja`
      );
    } else {
      if (selectedPaymentType === "credit card") {
        setRenderPaymentType("credit card");
      } else if (selectedPaymentType === "check") {
        setRenderPaymentType("check");
      } else {
        setRenderPaymentType("");
      }
      setShowManagerCreditCard(true);
    }
  };

  const paymentComponent = () => {
    return (
      <>
        <CommonButton
          sx={{ marginTop: "20px" }}
          disabled={cartItemsList.length === 0 || paymentButton}
          onClick={handleMakePayment}
        >
          Make Payment
        </CommonButton>
      </>
    );
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedId(null);
  };

  const handleAgree = () => {
    if (selectedId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      apiRequest({
        method: "DELETE",
        includeToken: true,
        endpoint: `${apiPath.deleteCartItem}/${selectedId}`,
      })
        .then((res) => {
          getCartItems();
          // Close the dialog
          handleClose();
          toast.custom(
            <SuccessPopup
              headerMessage="Cart Items"
              showMessage={LOCALE.ITEM_DELETED}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        })
        .catch((err) => {
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  };

  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            overflowY: "hidden",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <div className={styles.closeIcon} onClick={handleClose}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 1,
              top: 2,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to Delete the Item from the Cart?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const openConfirmPopUp = (id: number | undefined | null) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const tableAndPaymentComponent = () => {
    return (
      <>
        {tableComponent()}
        {cartItemsList.length > 0 && !hasManagerLevelRole && (
          <DevoteeModeOfPayment
            payPalAddToCart={payPalAddToCart}
            setButtonDisable={setpaymentButton}
            setSelectedPaymentType={setSelectedPaymentType}
          />
        )}
        {cartItemsList.length > 0 && hasManagerLevelRole && (
          <ModeOfPayment
            setButtonDisable={setpaymentButton}
            setSelectedPaymentType={setSelectedPaymentType}
          />
        )}
      </>
    );
  };

  const listComponentAndPayment = () => {
    return (
      <div style={{ width: "100%" }}>
        {!showSuccess ? tableAndPaymentComponent() : ""}
        {/* {(!hasManagerLevelRole && !paymentButton) ? paymentComponent() : ""} */}
        {/* Display ManagerCreditCardPayment component only when selectedPaymentType is "credit card" */}
        {cartItemsList.length > 0 &&
          selectedPaymentType === constants.CREDIT_CARD && (
            <ManagerCreditCardPayment
              amount={totalDonationAmount}
              setShowPayment={setShowManagerCreditCard}
              setShowSuccess={setShowSuccess}
              navigateBack={props.navigateBack}
            />
          )}

        {/* Display ManagerCheckPayment component only when selectedPaymentType is "check" */}
        {selectedPaymentType === "check" && (
          <ManagerCheckPayment
            amount={totalDonationAmount}
            setShowPayment={setShowManagerCreditCard} // You might need a different setShowPayment function for each payment type
            setShowSuccess={setShowSuccess}
            navigateBack={props.navigateBack}
          />
        )}
        {cartItemsList.length > 0 && (getUserSelectedRole()?.toLowerCase() !== "devotee") && selectedPaymentType === "paypal" && (
          <ManagerPayPalCartItems
          cartItemsList={cartItemsList}
            amount={totalDonationAmount}
            // setShowPayment={setShowPayment}
            setShowSuccess={setShowSuccess}
            navigateBack={props.navigateBack}
          />
        )}

        {dialogPopup()}
      </div>
    );
  };

  return <div>{listComponentAndPayment()}</div>;
};

export default CartItemsComponent;
